import { TComputedPropMapper } from '../../types/computed-props-mapper';

export const isColored: TComputedPropMapper<boolean> = ({ offer: { isColorized } }) => Boolean(isColorized);
